import * as Sentry from "@sentry/react"
import { useEffect } from "react"
import { ToastContainer } from "react-toastify"
import Flow from "./components/flow"
import GlobalBottomSheet from "./components/global-bottom-sheet"
import "react-toastify/dist/ReactToastify.css"
import { getUserData, hideProgressBar } from "./shared/app-interface"
import { APP_INTERACTION_TYPES, INVOKED_SOURCE_KEY, JOB_ID_KEY } from "./shared/constants"

function App() {
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has("client") && searchParams.get("client") === "android") {
            const userData = getUserData()
            const token = userData.accessToken
            const userLang = userData.language

            sessionStorage.setItem(
                INVOKED_SOURCE_KEY,
                searchParams.get("job_invoked_source") || ""
            )
            sessionStorage.setItem(JOB_ID_KEY, searchParams.get("job_id") || "")
            sessionStorage.setItem("__token__", token)
            sessionStorage.setItem("__userLang__", userLang)
        }

        const handleAccessToken = (e: any) => {
            if (e.detail.accessToken) {
                sessionStorage.setItem("__token__", e.detail.accessToken)
                ;(window as any).refreshingToken = false
            }
        }
        window.addEventListener(APP_INTERACTION_TYPES.ACCESS_TOKEN, handleAccessToken)

        window.removeEventListener(APP_INTERACTION_TYPES.ACCESS_TOKEN, handleAccessToken)
    }, [])
    ;(window as any).getAppData = (appData: any) => {
        const appDataJson = JSON.parse(appData)
        const event = new CustomEvent(`${appDataJson.type}`, {
            detail: appDataJson?.data,
        })
        window.dispatchEvent(event)
    }

    hideProgressBar()
    console.log("Test Production")
    return (
        <Sentry.ErrorBoundary>
            <div>
                <GlobalBottomSheet />
                <Flow />
            </div>
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable={false}
                    pauseOnHover
                    theme="colored"
                />
            </div>
        </Sentry.ErrorBoundary>
    )
}

export default App
